import React, { useState } from 'react';
import ValueSelector from '../../../elementSelector/selectors/ValueSelector';
import { dataToValueOption } from '../../../elementSelector/selectors/picker/valuePickerUtils';

/**
 * Example preSelectedValue
    {
        contentType: "ContentNumber"
        developerName: "number dfdsf"
        elementMeta: "Number"
        elementName: "number dfdsf"
        id: "7a9a622e-c3f3-4411-90d3-58c13ec87ade"
        parentContentType: null
        propertyId: null
    }
 */

const OperationValueSelector = ({
    selectorId,
    value,
    onChange,
    contentTypeFilter,
    typeElementIdFilter,
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedValueOption, setSelectedValueOption] = useState(
        value ? dataToValueOption(value) : null,
    );

    const onValueToChangeSelect = (valueMeta, id, elementReference) => {
        setSelectedValueOption(valueMeta);
        onChange(elementReference);
        setIsOpen(false);
    };

    return (
        <ValueSelector
            id={selectorId}
            isOpen={isOpen}
            preSelectedValue={selectedValueOption}
            toggleModal={setIsOpen}
            selectValue={onValueToChangeSelect}
            contentTypeFilter={contentTypeFilter}
            typeElementIdFilter={typeElementIdFilter}
        />
    );
};

export default OperationValueSelector;
